/* src/app/shared/components/form-controls/ag-input-percentage/ag-input-percentage.component.scss */
.disabled {
  opacity: 0.5;
}
.disabled input:disabled {
  background-color: white;
}
.ag-form-control {
  width: 123px;
}
.separator {
  border-left: solid 1px #ccc;
  padding: 0 0 0 13px;
  font-size: 13px;
  color: #333;
  width: 35px;
  display: flex;
  align-items: center;
}
/*# sourceMappingURL=ag-input-percentage.component.css.map */
